export const LOCATION_IQ = 'locationIQ';
export const GOOGLE = 'google';
export const OSM = 'osm';
export const allProviders = ['google', 'osm', 'locationIQ'];
